const currentYear = new Date().getFullYear();

export default function Footer() {
  return (
    <footer className="bg-md-ink">
      <div className="mx-auto max-w-[1200px] px-6 pb-20 md:pb-8 pt-16 md:px-12 md:pt-16">
        <div className="grid gap-12 md:grid-cols-4">
          {/* Brand */}
          <div>
            <div className="mb-5 flex items-center gap-3">
              <img
                src="https://static.readdy.ai/image/100c669628d567e493b0574d25985585/fdd0fbd9bd30abc0ce68dc53ed7f4af7.jpeg"
                alt="Logo Multidroguerías"
                className="h-14 w-14 rounded-lg object-cover"
              />
              <div className="flex flex-col">
                <span className="font-serif text-[18px] font-bold leading-tight text-white">
                  Multidroguerías
                </span>
                <span className="text-[11px] font-medium text-md-slate">
                  Servicio de domicilio
                </span>
              </div>
            </div>
            <p className="max-w-[280px] text-[14px] leading-[1.6] text-[#ddd] md:text-[15px]">
              Droguería con punto físico en Pereira. Domicilios en Pereira y Dosquebradas. Atención humana, cobertura local, servicio rápido.
            </p>
          </div>

          {/* Service */}
          <div>
            <h4 className="mb-5 text-[14px] font-bold uppercase tracking-wide text-white/60">
              Servicio
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Cómo pides', href: '#como-pides' },
                { label: 'Cobertura', href: '#cobertura' },
                { label: 'Qué llevamos', href: '#que-llevamos' },
                { label: 'Visítanos', href: '#visitanos' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-[14px] text-[#ddd] underline transition-colors hover:text-md-teal md:text-[15px]"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="mb-5 text-[14px] font-bold uppercase tracking-wide text-white/60">
              Contacto
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-center gap-2 text-[14px] text-[#ddd] md:text-[15px]">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-phone-line" />
                </span>
                <a
                  href="tel:+573206789030"
                  className="underline transition-colors hover:text-md-teal"
                  onClick={() => {
                    if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).mdCallClick) {
                      ((window as unknown as Record<string, unknown>).mdCallClick as () => void)();
                    }
                  }}
                >
                  +57 320 678 9030
                </a>
              </li>
              <li className="flex items-start gap-2 text-[14px] text-[#ddd] md:text-[15px]">
                <span className="flex h-4 w-4 flex-shrink-0 items-center justify-center pt-0.5">
                  <i className="ri-map-pin-line" />
                </span>
                Calle 24 # 19-18 Local 101, Pereira
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="mb-5 text-[14px] font-bold uppercase tracking-wide text-white/60">
              Información legal
            </h4>
            <ul className="flex flex-col gap-2">
              <li className="text-[13px] text-[#ddd]">
                Razón social: Multidroguerías
              </li>
              <li className="text-[13px] text-[#ddd]">
                NIT: 901.669.353-5
              </li>
              <li className="text-[13px] text-[#ddd]">
                Concepto sanitario: 066-001-1171-MED-23
              </li>
              <li className="text-[13px] text-[#ddd]">
                Director Técnico Q.F.: Juan Henao Castañeda
              </li>
            </ul>
          </div>
        </div>

        <div className="my-8 h-px bg-white/10" />

        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <p className="text-[13px] text-[#ddd] md:text-[14px]">
            &copy; {currentYear} Multidroguerías. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="/politica-de-privacidad/"
              className="text-[13px] text-[#ddd] underline transition-colors hover:text-md-teal md:text-[14px]"
            >
              Política de privacidad
            </a>
            <a
              href="/terminos-y-condiciones/"
              className="text-[13px] text-[#ddd] underline transition-colors hover:text-md-teal md:text-[14px]"
            >
              Términos y condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}